import angular from "angular";
import uiRouter from "angular-ui-router";
import Common from "./common/common";
import Components from "./components/components";
import Services from "./services/services";
import Constants from "./constants/constants";
import AppComponent from "./app.component";
import Translate from "angular-translate";
import uiGrid from "angular-ui-grid";
import uiSelect from "ui-select";
import ngSanitize from "angular-sanitize";
import datePicker from "angularjs-bootstrap-datetimepicker";
import ngMap from "ngmap";
import ngDialog from "ng-dialog";
import "ng-animated-scroll";
import el from "./translations/el.json";
import en from "./translations/en.json";
import ar from "./translations/ar.json";

import "normalize.css";

/* FONT AWESOME CSS LOADER */
import "font-awesome-loader";

import "angular-ui-router/release/stateEvents";

let app = angular
  .module("app", [
    uiRouter,
    Common,
    Components,
    Services,
    Constants,
    Translate,
    uiGrid,
    uiSelect,
    ngSanitize,
    datePicker,
    ngMap,
    ngDialog,
    "ui.router.state.events",
    "AnimatedScroll",
  ])
  .config(
    (
      URLS,
      $locationProvider,
      $translateProvider,
      $urlRouterProvider,
      $compileProvider,
      Settings
    ) => {
      "ngInject";

      /* Location */
      $locationProvider.html5Mode(true).hashPrefix("!");

      /* Translation */
      $translateProvider
        .translations("el", el)
        .translations("en", en)
        .translations("ar", ar)
        .preferredLanguage(Settings.PREF_LANGUAGE);

      /* Redirect to dashboard by default */
      $urlRouterProvider.when("/", "/dashboard");

      /* Disable Debug */
      $compileProvider.debugInfoEnabled(Settings.DEBUG);
    }
  )
  .run(
    (
      User,
      $rootScope,
      $window,
      $state,
      $stateParams,
      Permissions,
      $filter,
      ngDialog,
      Settings
    ) => {
      "ngInject";

      let $translate = $filter("translate");

      /* AdBlocker */
      if (!canRunAds) {
        ngDialog.open({
          template: "errorTemplate",
          data: {
            message: $translate("AD_BLOCK_MESSAGE"),
          },
        });
      }

      $rootScope.app = {
        name: "Velos",
        operator: Settings.OPERATOR,
      };

      $rootScope.isLoading = false;

      /* Bind State and State Params */
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;

      /* Permissions */
      $rootScope.permissions = Permissions;

      $rootScope.isRTL =
        $window.localStorage.getItem("vLanguage") &&
        $window.localStorage.getItem("vLanguage") === "ar";

      $rootScope.isEOT = Settings.OPERATOR === Settings.OPERATORS.EOT;
      $rootScope.isSAAF = Settings.OPERATOR === Settings.OPERATORS.SAAF;

      /* if responsible design */
      $rootScope.isSmart = () => {
        let ua =
          $window["navigator"]["userAgent"] ||
          $window["navigator"]["vendor"] ||
          $window["opera"];
        return /iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/.test(
          ua
        );
      };

      /* Check if user logged in */
      $rootScope.isUserLoggedIn = false;
      if ($window.localStorage.getItem("token")) {
        $rootScope.isUserLoggedIn = true;
        $rootScope.token = $window.localStorage.getItem("token");
        $rootScope.currentUser = JSON.parse(
          $window.localStorage.getItem("user")
        );
        $rootScope.user = User.build($rootScope.currentUser);
      }

      /* Check if user has selected Match */
      $rootScope.currentMatchId = null;
      $rootScope.currentMatch = null;
      if ($window.localStorage.getItem("currentMatchId")) {
        $rootScope.currentMatchId =
          $window.localStorage.getItem("currentMatchId");
        $rootScope.currentMatch = JSON.parse(
          $window.localStorage.getItem("currentMatch")
        );
      }

      $rootScope.showLeftSidebar = true;
      $rootScope.showHeader = true;
      $rootScope.showFooter = true;

      /* Check in case user logged out or token does not exists */
      $rootScope.$on(
        "$stateChangeStart",
        (event, toState, toParams, fromState, fromParams) => {
          $window.scrollTo(0, 0);
          let isLogin = toState.name === "login";
          let isReset = toState.name === "reset";
          let isRecover = toState.name === "recover";
          let isResults = toState.name === "results";
          let isPrivacy = toState.name === "privacy";
          let isMatchShotsIndividualVisual =
            toState.name === "match-profile.shotsIndividualVisual";
          if (isMatchShotsIndividualVisual) {
            $rootScope.showLeftSidebar = false;
            $rootScope.showHeader = false;
            $rootScope.showFooter = false;
          } else {
            $rootScope.showLeftSidebar = true;
            $rootScope.showHeader = true;
            $rootScope.showFooter = true;
          }
          if (
            isLogin ||
            isReset ||
            isRecover ||
            isResults ||
            isPrivacy ||
            isMatchShotsIndividualVisual
          ) {
            return;
          }

          let token = $window.localStorage.getItem("token");
          let isUserLoggedIn = $rootScope.isUserLoggedIn;
          if (!token || !isUserLoggedIn) {
            $rootScope.logout();
            event.preventDefault();
          }

          if (toState.name === "") {
            $state.go("dashboard");
            event.preventDefault();
          }
        }
      );

      /* Logout user */
      $rootScope.logout = () => {
        $rootScope.isUserLoggedIn = false;
        $window.localStorage.clear();
        $state.go("login");
      };

      /* Select Current Match*/
      $rootScope.updateMatchData = (matchData) => {
        $rootScope.currentMatch = matchData;
        $rootScope.currentMatchId = matchData.match_id;
        $window.localStorage.setItem(
          "currentMatch",
          JSON.stringify($rootScope.currentMatch)
        );
        $window.localStorage.setItem(
          "currentMatchId",
          $rootScope.currentMatchId
        );
      };

      /* Clear Match Data */
      $rootScope.clearMatchData = () => {
        delete $rootScope.currentMatchId;
        delete $rootScope.currentMatch;
        delete $window.localStorage.currentMatchId;
        delete $window.localStorage.currentMatch;
      };
    }
  );

if (
  window.localStorage.getItem("vLanguage") &&
  window.localStorage.getItem("vLanguage") == "ar"
) {
  app.component("app", require("./app.component-rtl").default);
} else {
  app.component("app", AppComponent);
}



// WEBPACK FOOTER //
// ./client/app/app.js